import { useApkDownload } from "@/lib/useApkDownload";

const QUICK_LINKS = [
  { label: "Home", href: "#home" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Rates", href: "#rates" },
  { label: "Security", href: "#security" },
  { label: "FAQ", href: "#faqs" },
  { label: "Contact", href: "#contact" },
];

const LEGAL = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms & Conditions", href: "/terms-and-conditions" },
  { label: "Risk Disclosure", href: "/risk-disclosure" },
];

export default function Footer() {
  const { downloading, start } = useApkDownload();
  return (
    <footer id="contact" className="border-t border-line bg-pine text-paper" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="logo-chip">
              <img src="/assets/logo-wordmark.png" alt="Rupora" className="h-7 w-auto" data-testid="footer-logo" />
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-mist">
              Clean fund exchange with a transparent, verification-first process — competitive
              market rates and clear transaction status throughout.
            </p>
            <p className="mt-5 text-sm text-mist/70">
              Need help? Support is available inside the Rupora app.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-mist/60">Quick Links</h4>
            <ul className="mt-5 space-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.label}>
                  <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-paper/65 transition-colors duration-300 hover:text-brand-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-mist/60">App</h4>
            <ul className="mt-5 space-y-3">
              <li>
                <button onClick={start} disabled={downloading} data-testid="footer-download-button" className="text-sm text-paper/65 transition-colors duration-300 hover:text-brand-300 disabled:opacity-70">
                  {downloading ? "Downloading..." : "Download Android App"}
                </button>
              </li>
              <li>
                <a href="/login" data-testid="footer-get-started-link" className="text-sm text-paper/65 transition-colors duration-300 hover:text-brand-300">
                  Get Started
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-mist/60">Legal</h4>
            <ul className="mt-5 space-y-3">
              {LEGAL.map((l) => (
                <li key={l.label}>
                  <a href={l.href} data-testid={`footer-legal-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-sm text-paper/65 transition-colors duration-300 hover:text-brand-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-line pt-8 sm:flex-row">
          <p className="text-xs text-mist/60" data-testid="footer-copyright">© 2026 Rupora. All rights reserved.</p>
          <p className="text-xs text-mist/40">Rates are indicative and may vary with market conditions. Review the final rate before every transaction.</p>
        </div>
      </div>
    </footer>
  );
}
